import { neutral } from '../../../theme/light-theme-options';

export const style = {
  clearBtn: {
    color: 'action.active',
  },
  box: {
    inner: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      backgroundColor: neutral[100],
      borderRadius: 1,
      p: 1,
    },
    sx: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      p: 1,
    },
  },
} as const;
